export default "__VITE_ASSET__Cx89ikXi__"